/* eslint-disable @typescript-eslint/no-explicit-any */
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const CustomersPage = (props: Props): JSX.Element => {
    return (
        <S_CustomersPage className={props.className}>
            <CustomMapPage mapId={'ae913f8e-6868-4074-afc6-a00065b89dae'} />
        </S_CustomersPage>
    );
};

const S_CustomersPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
